import styled from 'styled-components'

export const TaskContainer = styled.div`
    width: 100%;
    background-color: #fff;
    padding: 20px;
    margin-top: 20px;
    border-radius: 5px;
    display: grid;
    align-self: start;
    justify-items: center;
    grid-gap: 20px;
    position: relative;
    overflow: hidden;
`